import { z } from 'zod'

import { TimeEntryStatusEnum } from './time-entry'

export enum TimeEntryStatusTierEnum {
  FINANCIAL_ACTUALS = 'FINANCIAL_ACTUALS',
  OPERATIONAL_VISIBILITY = 'OPERATIONAL_VISIBILITY',
  CUSTOM = 'CUSTOM',
}

export const FINANCIAL_ACTUALS_STATUSES = [
  TimeEntryStatusEnum.APPROVED,
  TimeEntryStatusEnum.COMPLETED,
] as const

export const OPERATIONAL_VISIBILITY_STATUSES = [
  TimeEntryStatusEnum.SUBMITTED,
  TimeEntryStatusEnum.APPROVED,
  TimeEntryStatusEnum.COMPLETED,
] as const

export const TimeEntryStatusTierSchema = z.nativeEnum(TimeEntryStatusTierEnum)

export const TIME_ENTRY_STATUS_TIERS = {
  [TimeEntryStatusTierEnum.FINANCIAL_ACTUALS]: FINANCIAL_ACTUALS_STATUSES,
  [TimeEntryStatusTierEnum.OPERATIONAL_VISIBILITY]:
    OPERATIONAL_VISIBILITY_STATUSES,
} as const

export const TIME_ENTRY_STATUS_TIER_LABELS: Record<
  Exclude<TimeEntryStatusTierEnum, TimeEntryStatusTierEnum.CUSTOM>,
  {
    reportLabel: string
    shortLabel: string
    description: string
  }
> = {
  [TimeEntryStatusTierEnum.FINANCIAL_ACTUALS]: {
    reportLabel: 'Financial actuals',
    shortLabel: 'Approved time only',
    description:
      'Showing only time entries that have been approved or completed. Use this for financial reporting, billing, and invoicing.',
  },
  [TimeEntryStatusTierEnum.OPERATIONAL_VISIBILITY]: {
    reportLabel: 'Operational visibility',
    shortLabel: 'Includes submitted time',
    description:
      'Showing time entries that have been submitted for approval plus already-approved entries. Use this for real-time team oversight and workload planning.',
  },
}

export function getStatusesForTimeEntryTier(
  tier?: TimeEntryStatusTierEnum | null,
) {
  if (!tier || tier === TimeEntryStatusTierEnum.CUSTOM) {
    return undefined
  }

  return [...TIME_ENTRY_STATUS_TIERS[tier]]
}
